import axios from 'axios'
import {http} from './config/config-relation-register'
import {http as httpReceituario} from './config/config-receituario'

const importBulaHttp = axios.create({
    baseURL: process.env.VUE_APP_API_RELATION_IMPORT_BULA || process.env.VUE_APP_API_RECEITUARIO || 'https://newapi.webreceita.com.br/webreceita/api/v1'
})

export default{
    listar:(token,itens_pagina,pagina,filter)=>{
        if(itens_pagina,pagina){
            return  http.get('itens-produto?itens_pagina='+itens_pagina+'&pagina='+pagina+'&filter='+encodeURIComponent(filter),{
                headers:{
                    'Authorization':token
                }
            })
        }else{
            return  http.get('itens-produto',{
                headers:{
                    'Authorization':token
                }
            })
        }
    },
    salvar:(token, item)=>{
        return http.post('itens-produto',item,{
            headers:{
                'Authorization':token
            }
        })
    },
    deletar:(token, idItem)=>{
        return http.delete('itens-produto/'+idItem,{
            headers:{
                'Authorization':token
            }
        })
    },
    update:(token, item)=>{
        return http.put('itens-produto/'+item.id_item_produto,item,{
            headers:{
                'Authorization':token
            }
        })
    },
    salvarEquipament:(token, itens)=>{
        return http.post('itens-produto/save-equipament',itens,{
            headers:{
                'Authorization':token
            }
        })
    },
    importarBula:(token, formData)=>{
        return importBulaHttp.post('newprod/import-bula', formData, {
            headers:{
                'Authorization':token,
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    importarPlanilha:(token, formData)=>{
        return httpReceituario.post('itens-produto/importar-planilha', formData, {
            headers:{
                'key':token,
                'Authorization':token,
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    importarPlanilhaCulturas:(token, formData)=>{
        return httpReceituario.post('itens-produto/importar-planilha/culturas', formData, {
            headers:{
                'key':token,
                'Authorization':token,
                'Content-Type': 'multipart/form-data'
            }
        })
    },
}
